import { useQueryParam } from "./useQuery";

export const useOpenTaskDrawer = () => {
  const [_, setTask] = useQueryParam<number>("task");
  return setTask as (id?: number | undefined) => void;
};
